import { render, staticRenderFns } from "./dingTalkCallback.vue?vue&type=template&id=160f8bfc&"
import script from "./dingTalkCallback.vue?vue&type=script&lang=js&"
export * from "./dingTalkCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports